"use client";

import React from "react";

/**
 * Card - Bordered content container with optional header/body/footer.
 *
 * @param {boolean} body - Shorthand to wrap children in Card.Body
 */
function CardComponent({ children, body = false, className = "", ...props }) {
  return (
    <div
      className={`bg-white border border-lightGrey3 rounded ${className}`.trim()}
      {...props}
    >
      {body ? <CardBody>{children}</CardBody> : children}
    </div>
  );
}

/**
 * Card.Header - Top section of a Card.
 */
function CardHeader({ children, className = "", ...props }) {
  return (
    <div
      className={`px-4 py-3 bg-lightGrey border-b border-lightGrey3 font-medium ${className}`.trim()}
      {...props}
    >
      {children}
    </div>
  );
}

/**
 * Card.Body - Main content area of a Card.
 */
function CardBody({ children, className = "", ...props }) {
  return (
    <div className={`p-4 ${className}`.trim()} {...props}>
      {children}
    </div>
  );
}

/**
 * Card.Title - Title within Card.Body.
 */
function CardTitle({ children, className = "", ...props }) {
  return (
    <h5 className={`mb-2 font-medium ${className}`.trim()} {...props}>
      {children}
    </h5>
  );
}

/**
 * Card.Text - Paragraph text within Card.Body.
 */
function CardText({ children, className = "", ...props }) {
  return (
    <p className={`mb-0 ${className}`.trim()} {...props}>
      {children}
    </p>
  );
}

/**
 * Card.Footer - Bottom section of a Card.
 */
function CardFooter({ children, className = "", ...props }) {
  return (
    <div
      className={`px-4 py-3 bg-lightGrey border-t border-lightGrey3 ${className}`.trim()}
      {...props}
    >
      {children}
    </div>
  );
}

export const Card = Object.assign(CardComponent, {
  Header: CardHeader,
  Body: CardBody,
  Title: CardTitle,
  Text: CardText,
  Footer: CardFooter,
});

export { CardHeader, CardBody, CardTitle, CardText, CardFooter };
